/* @flow */

import type { $Coordinates } from './Coordinates';

export type $MarketGeoMapping = {
  marketCode: Array<string>,
  center: $Coordinates,
  zoom: number,
  bounds?: mixed
};

type $MarketGeoMappings = {
  [marketName: string]: $MarketGeoMapping;
};

const MarketGeoMappings: $MarketGeoMappings = {
  PT: {
    marketCode: ['PT', 'pt'],
    center: {
      lat: 40.2033,
      lng: -8.4103
    },
    zoom: 7
  },
  ES: {
    marketCode: ['ES', 'es'],
    center: {
      lat: 39.8068,
      lng: -3.7038
    },
    zoom: 6
  }
};

export default MarketGeoMappings;
